import { Context, Controller } from '@hotwired/stimulus';

export default class ToastController extends Controller {
  constructor(context: Context) {
    super(context);
  }
}

// TODO: need to find an accessible way to implement this...
